import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../button/button';
import { Dialog } from '../dialog/dialog';
import { InfoBox } from '../info-box/info-box';

interface Props {
  onClose: () => void;
  onActivateSso: () => void;
  domain: string;
}

const SsoActivationDialog = ({ onClose, onActivateSso, domain }: Props) => {
  const { t } = useTranslation();

  const handleActivateSso = () => {
    onActivateSso();
    onClose();
  };

  return (
    <Dialog closeIcon={true} maxWidth={500} onClose={onClose}>
      {{
        header: t('ssoActivation.title', { ns: 'components' }),
        content: (
          <InfoBox color="blue" leftIcon={{ icon: ['fad', 'info-circle'] }}>
            {t('ssoActivation.description', { ns: 'components', domain })}
          </InfoBox>
        ),
        footer: {
          right: (
            <>
              <Button color="primary" type="button" variant="contained" onClick={handleActivateSso}>
                {t('ssoActivation.activateSso', { ns: 'components' })}
              </Button>
              <Button type="button" variant="text" onClick={onClose}>
                {t('cancel', { ns: 'common' })}
              </Button>
            </>
          ),
        },
      }}
    </Dialog>
  );
};

export { SsoActivationDialog };
